import { RouteConfig } from 'vue-router';
const Add = () => import('./views/add.vue');
const routers: RouteConfig[] = [
    {
        path: 'add',
        name: 'add',
        component: Add
    },
    {
        path: '',
        redirect: 'add'
    },
];
export default routers;

